import { createSlice } from "@reduxjs/toolkit";

export const WaitingListStatusSlice = createSlice({
    name: "waitingListEnabled",
    initialState: {
        waitingListEnabled: false,
    },
    reducers: {
        setWaitingListStatusEnabled: (state, action) => {
            state.waitingListEnabled = action.payload;
        },
    }
})

export const { setWaitingListStatusEnabled } = WaitingListStatusSlice.actions;

export default WaitingListStatusSlice.reducer;
